import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import {
  hasSequentialDigits,
  hasDisallowedWords,
  hasYearPattern,
  hasRepeatedChars,
  hasKeyboardPattern
} from 'services/validators'

const requirements = [
  { key: 'length', label: 'Mínimo 15 caracteres', test: (p) => p.length >= 15 },
  { key: 'uppercase', label: '2 mayúsculas', test: (p) => (p.match(/[A-Z]/g) || []).length >= 2 },
  { key: 'lowercase', label: '1 minúscula', test: (p) => /[a-z]/.test(p) },
  { key: 'digit', label: '1 número', test: (p) => /\d/.test(p) },
  { key: 'special', label: '3 caracteres especiales', test: (p) => (p.match(/[!@#$%^&*(),.?":{}|<>_\-+=\[\]\\\/`~;']/g) || []).length >= 3 },
  { key: 'noSequence', label: 'Sin secuencias (123, 321)', test: (p) => !hasSequentialDigits(p) },
  { key: 'noCommonWords', label: 'Sin palabras prohibidas', test: (p) => !hasDisallowedWords(p) },
  { key: 'noYear', label: 'Sin años (2000-2099)', test: (p) => !hasYearPattern(p) },
  { key: 'noRepeated', label: 'Sin caracteres repetidos (4+)', test: (p) => !hasRepeatedChars(p) },
  { key: 'noKeyboard', label: 'Sin patrones de teclado', test: (p) => !hasKeyboardPattern(p) },
]

const PasswordStrengthIndicator = ({ password = '', show = true }) => {
  if (!show) return null

  const metCount = requirements.filter(r => r.test(password)).length

  const getStrengthColor = () => {
    if (metCount <= 3) return 'weak'
    if (metCount <= 7) return 'medium'
    return 'strong'
  }

  const strengthClass = getStrengthColor()
  const percentage = (metCount / requirements.length) * 100

  return (
    <div className="password-strength-indicator">
      <div className="strength-bar-container">
        <div
          className={`strength-bar ${strengthClass}`}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <ul className="requirements-list">
        {requirements.map(req => (
          <li key={req.key} className={req.test(password) ? 'met' : ''}>
            <span className="check">{req.test(password) ? '✓' : '○'}</span>
            {req.label}
          </li>
        ))}
      </ul>
      <style jsx>{styles}</style>
    </div>
  )
}

PasswordStrengthIndicator.propTypes = {
  password: PropTypes.string,
  show: PropTypes.bool,
}

export default PasswordStrengthIndicator
